import * as React from "react";
import { forwardRef } from "react";
const SvgSender = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "#7DDFBB" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5358 10.534L8.53465 10.5409V6.87827L2.80874 12.6042C2.27257 12.2026 1.79608 11.7262 1.39453 11.19L7.12044 5.46406L3.46475 5.45715V3.46289H10.5358V10.534Z", fill: "#0C1119" }));
const ForwardRef = forwardRef(SvgSender);
export { ForwardRef as ReactComponent };
